export const OrdersDetailsType = {
	none: 0,
	warning: 1,
	error: 2,
};
